import type {BlockCategoryDataMap} from './email-maker-block-manager.types';

interface BlockConstants {
  CATEGORY_SECTIONS: string;
  CATEGORY_ELEMENTS: string;
  CATEGORY_TEXT: string;
  CATEGORY_IMAGE: string;
  CATEGORY_MY_DESIGNS: string;
  BLOCK_AI_EDIT: string;
}

export function buildBlockCategoryDataMap(blockConstants: BlockConstants): BlockCategoryDataMap {
  return {
    [blockConstants.CATEGORY_SECTIONS]: {
      icon: 'icon-section',
      labelKey: 'pmwjs_sections',
      descriptionKey: 'pmwjs_sections_block_description',
      introImageFilename: 'section-block-intro.png',
      introTextKey: 'pmwjs_sections_block_intro',
    },
    [blockConstants.CATEGORY_ELEMENTS]: {
      icon: 'icon-elements',
      labelKey: 'pmwjs_elements',
      descriptionKey: 'pmwjs_elements_block_description',
      introImageFilename: 'elements-block-intro.png',
      introTextKey: 'pmwjs_elements_block_intro',
    },
    [blockConstants.CATEGORY_TEXT]: {
      icon: 'icon-text',
      labelKey: 'pmwjs_text',
      descriptionKey: 'pmwjs_text_block_description',
      introImageFilename: 'text-block-intro.png',
      introTextKey: 'pmwjs_text_block_intro',
    },
    [blockConstants.CATEGORY_IMAGE]: {
      icon: 'icon-image',
      labelKey: 'pmwjs_image',
      descriptionKey: 'pmwjs_image_block_description',
      introImageFilename: 'image-block-intro.png',
      introTextKey: 'pmwjs_image_block_intro',
    },
    [blockConstants.CATEGORY_MY_DESIGNS]: {
      icon: 'icon-designs',
      labelKey: 'pmwjs_my_designs',
      descriptionKey: 'pmwjs_my_designs_block_description',
      introImageFilename: 'my-designs-block-intro.png',
      introTextKey: 'pmwjs_my_designs_block_intro',
    },
    [blockConstants.BLOCK_AI_EDIT]: {
      icon: 'icon-sparkle',
      labelKey: 'pmwjs_ai_edit',
      descriptionKey: 'pmwjs_ai_edit_block_description',
      introImageFilename: null,
      introTextKey: null,
    },
  };
}
